import { $$Whole } from "../../../helpers";

export const getMedigapPriceRange = (min: number, max: number): string => {
  const minWhole = Math.round(min);
  const maxWhole = Math.round(max);

  return minWhole === maxWhole
    ? $$Whole(minWhole)
    : `${$$Whole(minWhole)}-${$$Whole(maxWhole)}`;
};
